import Colors, { withOpacity, } from '@polestar/component-warehouse-react/tokens/colors/Colors';
import Opacities from '@polestar/component-warehouse-react/tokens/opacities/Opacities';
import Emphasis from '@polestar/component-warehouse-react/tokens/emphasis/Emphasis';
const QuoteTheme = {
    quote: {
        light: {
            emphasis: {
                [Emphasis.medium]: {
                    title: { color: Colors.black },
                    note: { color: withOpacity(Colors.black, Opacities.medium) },
                },
                [Emphasis.low]: {
                    title: { color: withOpacity(Colors.black, Opacities.medium) },
                    note: { color: withOpacity(Colors.black, Opacities.medium) },
                },
            },
        },
        dark: {
            emphasis: {
                [Emphasis.medium]: {
                    title: { color: Colors.white },
                    note: { color: withOpacity(Colors.white, Opacities.medium) },
                },
                [Emphasis.low]: {
                    title: { color: withOpacity(Colors.white, Opacities.medium) },
                    note: { color: withOpacity(Colors.white, Opacities.medium) },
                },
            },
        },
    },
};
export default QuoteTheme;
